import { createSlice } from "@reduxjs/toolkit";

type State = {
    classifierCode?: string;
    classifierRecordCode?: string;
    lodResourceCode?: string;
    staticPageTitle?: string;
};

const initialState: State = {
    classifierCode: undefined,
    classifierRecordCode: undefined,
    lodResourceCode: undefined,
    staticPageTitle: undefined,
};

const breadcrumbsSlice = createSlice({
    name: "breadcrumbs",
    initialState,
    reducers: {
        resetBreadcrumbState: () => initialState,
        setBreadcrumbClassifierCode: (
            state,
            { payload }: { payload: string }
        ) => {
            state.classifierCode = payload;
        },
        setBreadcrumbClassifierRecordCode: (
            state,
            { payload }: { payload: string }
        ) => {
            state.classifierRecordCode = payload;
        },
        setBreadcrumbLodResourceCode: (
            state,
            { payload }: { payload: string }
        ) => {
            state.lodResourceCode = payload;
        },
        setStaticPageTitle: (state, { payload }: { payload: string }) => {
            state.staticPageTitle = payload;
        },
    },
});

export const {
    resetBreadcrumbState,
    setBreadcrumbClassifierCode,
    setBreadcrumbClassifierRecordCode,
    setBreadcrumbLodResourceCode,
    setStaticPageTitle,
} = breadcrumbsSlice.actions;

export default breadcrumbsSlice.reducer;
